import { BASE_URL, AUTH_URL, GRAPHQL_URL } from "./config";

////////////////////////////////
// ACCOUNT

export const login = (credentials) => {
  return {
    url: BASE_URL + AUTH_URL,
    method: "POST",
    data: credentials,
  };
};

export const getAllAdminUsers = () => {
  return {
    url: BASE_URL + GRAPHQL_URL,
    method: "POST",
    data: {
      query: `
        query {
          users (
            where: {
              role: {
                type_in: ["admingestionale", "supervisorgestionale", "usergestionale"]
              }
            }
          ) {
            id,
            email,
            role {
              id
              type
            }
          }
        }
      `,
    },
  };
};

export const updateUser = (userId, email, password) => {
  return {
    url: BASE_URL + GRAPHQL_URL,
    method: "POST",
    data: {
      query: `
        mutation {
          updateUser (
            input: {
              where: {
                id: ${userId}
              }
              data: {
                email: "${email}"
                password: "${password}"
              }
            }
          ) {
            user {
              id
            }
          }
        }
      `,
    },
  };
};

////////////////////////////////
// APARTMENTS

export const getAllApartments = () => {
  return {
    method: "POST",
    url: "https://backoffice.arboutiqueapartments.it/graphql",
    data: {
      query: `
      query {
        appartamentos {
            id, 
            identificativo
            user {
              id
              prenotaziones {
                id
                created_at
                evaso
                printed
                servizio_nome
                servizio_prezzo
                servizio_durata
                mittente
                numero_consegna
                data_consegna_prevista
                ora_consegna_prevista
                descrizione_consegna
                data_prenotazione
                si_ripete
                frequenza_ripetizione
                giorno_ripetizione
                ora_ripetizione
                id_ripetizione
                servizio {
                  id
                  identificativo
                  prezzo
                  nome
                  descrizione
                }
                sottoprenotaziones {
                  id
                  quantita
                  sottoservizio_nome
                  sottoservizio_prezzo
                  sottoservizio_durata
                  sottoservizio {
                    id
                    nome
                    descrizione
                    prezzo
                  }
                }
              }
              versamentos {
                id
                quantita
                data_esecuzione
                created_at
              }
              messaggios_to {
                id
                from {
                  id
                  email,
                  username
                },
                testo
                created_at
              }
              messaggios_sent {
                id,
                to {
                  id
                  email,
                  username
                },
                testo,
                created_at
              }
            }
          }
        }
      `,
    },
  };
};

export const sendMessage = (userId, adminId, text) => {
  return {
    method: "POST",
    url: "https://backoffice.arboutiqueapartments.it/graphql",
    data: {
      query: `
        mutation {
          createMessaggio (
            input: {
              data: {
                testo: "${text}"
                to: ${userId}
                from: ${adminId}
              }
            }
          ) {
            messaggio {
              id
              testo
            }
          }
        }
      `,
    },
  };
};

export const updateReservations = (reservationId, data) => {
  return {
    method: "POST",
    url: "https://backoffice.arboutiqueapartments.it/graphql",
    data: {
      query: `
        mutation {
          updatePrenotazione(
            input: {
              where: {
                id: ${reservationId}
              },
              data: {
                ${Object.entries(data).map((att) => att[0] + ": " + att[1])}
              }
            }
          ) {
            prenotazione {
              id,
              evaso
            }
          }
        }
      `,
    },
  };
};

export const addVersamento = (userId, date, quantita) => {
  return {
    method: "POST",
    url: "https://backoffice.arboutiqueapartments.it/graphql",
    data: {
      query: `
        mutation {
          createVersamento(
            input: {
              data: {
                user: ${userId}
                data_esecuzione: "${date}"
                quantita: ${quantita}
              }
            }
          ) {
            versamento {
              id
            }
          }
        }
      `,
    },
  };
};

export const removeUserFromApartment = (apartmentId) => {
  const jwt = localStorage.getItem("jwt");
  return {
    method: "POST",
    url: "https://backoffice.arboutiqueapartments.it/graphql",
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
    data: {
      query: `
        mutation {
          updateAppartamento(
            input: {
              where: {
                id: ${apartmentId}
              }
              data: {
                user: null
              }
            }
          ) {
            appartamento {
              id
            }
          }
        }
      `,
    },
  };
};

////////////////////////////////
// SERVICES

export const getAllServices = () => {
  return {
    method: "POST",
    url: "https://backoffice.arboutiqueapartments.it/graphql",
    data: {
      query: `
        query {
          servizios {
              id 
              identificativo
              nome
          }
        }
      `,
    },
  };
};
